import './Icon.4e79bcf9f042204502388f506151d3db.css';
export default {"icon":"_icon_vqf6m_1"};